import { LinearProgress, Box, Typography } from '@mui/material'

interface ProgressBarProps {
  value?: number
  message?: string
  indeterminate?: boolean
}

function ProgressBar({ value = 0, message = '', indeterminate = false }: ProgressBarProps) {
  return (
    <Box sx={{ width: '100%' }}>
      {message && (
        <Typography variant="body2" color="text.secondary" gutterBottom>
          {message}
        </Typography>
      )}
      {indeterminate ? (
        <LinearProgress />
      ) : (
        <LinearProgress variant="determinate" value={value} />
      )}
      {!indeterminate && value > 0 && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {`${Math.round(value)}%`}
        </Typography>
      )}
    </Box>
  )
}

export default ProgressBar